import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { ContractTypeGroupModel } from './../models/contracttypegroup.model';
import { ContractTypeGroupService } from './../models/contracttypegroup.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { VehicleModel } from '../../vehicle/models/vehicle.model';


@Component({
  selector: 'wego-inactive-contracttypegroup-popup',
  template: require('../views/add-contracttypegroup-popup.component.html'),
  styles: [`
  fieldset{
    margin-bottom: 10px;
  }

  legend{
    margin-bottom: 8px;
    font-size: 16px;
  }
  `]
})


export class InActiveContractTypeGroupPopupComponent implements OnInit {
  reasonList: any;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  contractTypeGroupHashId: string;
  sharedVehicleGroupHashId: string;

  @ViewChild('contractGroupModal') public contractGroupModal: any;

  constructor(private contractTypeGroupService: ContractTypeGroupService
    , private authService: AuthService
    , private activeRoute: ActivatedRoute
    , private router: Router, private translate: TranslateService) { }

  ngOnInit() {

  }

  public show(): void {
    console.log(this.contractTypeGroupHashId);
    this.GetInActiveReason();
    this.contractGroupModal.show();
  }

  public hide(): void {
    this.contractGroupModal.hide();
  }

  public GetInActiveReason() {
    this.isLoading = true;
    this.contractTypeGroupService.GetInActiveReasonByHashId(this.contractTypeGroupHashId)
      .subscribe(
      res => {
        this.reasonList = res.data;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contracttypegroup/components/add-contracttypegroup-popup.component.ts